import React, { useState } from "react";
import Shell from "@/components/Shell";
import api, { formatError } from "@/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function MyAccount() {
  const { user, refresh } = useAuth();
  const [fullName, setFullName] = useState(user?.full_name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [busyP, setBusyP] = useState(false);
  const [busyN, setBusyN] = useState(false);

  const updateProfile = async (e) => {
    e.preventDefault();
    setBusyN(true);
    try {
      await api.put("/api/auth/profile", { full_name: fullName, email });
      toast.success("Profile updated");
      await refresh();
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setBusyN(false);
    }
  };

  const changePw = async (e) => {
    e.preventDefault();
    if (nw.length < 6) return toast.error("New password must be at least 6 chars");
    setBusyP(true);
    try {
      await api.put("/api/auth/password", { current_password: cur, new_password: nw });
      setCur("");
      setNw("");
      toast.success("Password changed");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setBusyP(false);
    }
  };

  return (
    <Shell>
      <div className="vbs-page-eye">ACCOUNT</div>
      <h1 className="vbs-page-h">My <em>account</em></h1>
      <p className="vbs-page-p">Manage your profile and password.</p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 18 }}>
        <form onSubmit={updateProfile} className="vbs-card" style={{ padding: 24, display: "flex", flexDirection: "column", gap: 14 }}>
          <div style={{ fontFamily: "var(--font-display)", fontSize: 20, fontWeight: 700, color: "var(--white)" }}>Profile</div>
          <label>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--gold-dim)", letterSpacing: 1.5, marginBottom: 6, textTransform: "uppercase" }}>Full name</div>
            <input data-testid="profile-name" className="vbs-input" value={fullName} onChange={(e) => setFullName(e.target.value)} />
          </label>
          <label>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--gold-dim)", letterSpacing: 1.5, marginBottom: 6, textTransform: "uppercase" }}>Email</div>
            <input data-testid="profile-email" className="vbs-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <button data-testid="save-profile-btn" className="vbs-btn vbs-btn-gold" type="submit" disabled={busyN}>{busyN ? "Saving…" : "Save profile"}</button>
        </form>

        <form onSubmit={changePw} className="vbs-card" style={{ padding: 24, display: "flex", flexDirection: "column", gap: 14 }}>
          <div style={{ fontFamily: "var(--font-display)", fontSize: 20, fontWeight: 700, color: "var(--white)" }}>Password</div>
          <label>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--gold-dim)", letterSpacing: 1.5, marginBottom: 6, textTransform: "uppercase" }}>Current password</div>
            <input data-testid="current-password" className="vbs-input" type="password" value={cur} onChange={(e) => setCur(e.target.value)} required />
          </label>
          <label>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--gold-dim)", letterSpacing: 1.5, marginBottom: 6, textTransform: "uppercase" }}>New password</div>
            <input data-testid="new-password" className="vbs-input" type="password" value={nw} onChange={(e) => setNw(e.target.value)} required minLength={6} />
          </label>
          <button data-testid="change-password-btn" className="vbs-btn vbs-btn-gold" type="submit" disabled={busyP}>{busyP ? "Changing…" : "Change password"}</button>
        </form>
      </div>
    </Shell>
  );
}
